import React, { Component } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import Loading from 'components/Elements/Loading';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from 'components/Cards/CardDeal';
import HeaderText from 'components/Elements/HeaderText';
import API from 'configs/ApiConfig';
import _ from 'lodash';
import { Link } from 'react-router-external';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import('slick-carousel/slick/slick.css');
import('slick-carousel/slick/slick-theme.css');

const styles = theme => ({
  root: {
  },
  fullWidth: {
    width: '100%',
  },
});
class CardDeals extends Component {
    state = {
      isLoadingMore: false,
      _params: null,
      _data: null,
      _page: 0,
      hasMore: true,
    }

    componentWillMount() {
      const { loadMore, totalPages } = this.props;

      this.setState({
        _params: loadMore && _.merge(loadMore.params, {
          page: 1,
        }),
        _data: this.props.data || [],
        hasMore: !((totalPages && totalPages === 1)),
      });
    }

    componentWillReceiveProps() {
      const { scroll, loadMore } = this.props;
      const { hasMore, isLoadingMore } = this.state;

      if (scroll && scroll.top > 0.9 && loadMore && hasMore && !isLoadingMore) {
        this.delayedLoading();
      }
    }

    loadMoreBtnClick(e) {
      this.delayedLoading();
    }

    delayedLoading() {
      const { loadMore, delay } = this.props;
      const {
        hasMore, _params, _page, _data, isLoadingMore,
      } = this.state;

      if (!isLoadingMore && hasMore) {
        this.setState({
          isLoadingMore: true,
        });
      }

      setTimeout(() => {
        if (loadMore && loadMore.api && hasMore) {
          if (_page < _params.page) {
            API.get(`/${loadMore.api}`, { params: _params }).then((response) => {
              const _tempData = _data;


              _.mapValues(response.data.data, (resData) => {
                if (!_.find(_tempData, { id: resData.id })) {
                  _tempData.push(resData);
                }
              });

              this.setState({
                _params: _.merge(_params, { page: _params.page + 1 }),
                isLoadingMore: false,
                _data: _tempData,

              });

              if ((response.data.totalPages - 1) <= response.data.currentPage) {
                this.setState({
                  hasMore: false,
                });
              }
            });

            this.setState({
              _page: _page + 1,
            });
          }
        }
      }, delay || 3000);
    }

    render() {
      const {
        classes, data, title, subtitle, filters, children, total,
        loadMore, readMore, loadMoreText, emptyMessage, haveBorder, isSlider,
      } = this.props;

      const { hasMore, _data, isLoadingMore } = this.state;

      const defaultEmptyMessage = (
        <div>
          <Typography className="text-24 text-center font-serif text-grey-dark self-center">
              Ooops! There must be some missed steak!
          </Typography>
          <Typography className="text-18 text-center font-sans text-grey-dark self-center">
            {"We're looking into it. Try refreshing the page or select another option."}
          </Typography>
        </div>
      );

      return (
        <div className={classNames('my-20 min-h', haveBorder && classes.className)}>
          {(title || subtitle)
              && (
                <HeaderText
                  small
                  title={title}
                  subtitle={subtitle}
                />
              )
          }
          {filters
              && (
                <div className="my-28">
                  {filters}
                </div>
              )
          }
          <div className="my-28">
            {children}
          </div>
          {data
                  && (
                    <Grid container className={classNames(classes.root, !isSlider && 'container')} spacing={24} justify="flex-start">
                      {_data.length ? _data.map(content => (
                        <Grid key={content.uob_deal_id} item xs={12} md={6} lg={3}>
                          <Card
                            key={content.uob_deal_id}
                            {...this.props}
                            content={content}
                          />
                        </Grid>
                      ))
                        : (
                          <Grid item justify="center" alignItems="center" className="flex flex-1 p-32 min-h-288">
                            <Typography className="text-24 font-sans text-grey-dark self-center ">
                              {emptyMessage || defaultEmptyMessage}
                            </Typography>
                          </Grid>
                        )}

                      {loadMore && _data && _data.length > 0 && (total ? (_data.length < total) : true) && (
                        <Grid container justify="center" alignItems="center">
                          {isLoadingMore
                            ? (
                              <div className="p-20">
                                <Loading />
                              </div>
                            )
                            : (hasMore
                            && (
                              <Button
                                onClick={this.loadMoreBtnClick.bind(this)}
                                className={classNames('my-20 tracking-wide button-outlined-black p-12 pb-8 px-16 uppercase leading-none border-3 border-solid border-grey-darkest font-bold lg:text-18 sm:text-14 xs:text-12 text-grey-darkest')}
                              >
                                {loadMoreText || 'Load More'}
                                <ExpandMoreIcon />
                              </Button>
                            )
                            )
                          }
                        </Grid>
                      )}
                      {readMore && !loadMore && (
                        <Grid container justify="center" alignItems="center">
                          <Button
                            component={Link}
                            to={readMore}
                            className={classNames('my-20 tracking-wide button-outlined-black p-12 pb-8 px-16 uppercase leading-none border-3 border-solid border-grey-darkest font-bold lg:text-18 sm:text-14 xs:text-12 text-grey-darkest relative')}
                            data-track={`read more >> ${readMore}`}
                          >
                            <span className="block">
                            Read More
                              <span
                                className="block absolute w-full h-full pin-t pin-l"
                                data-track={`read more >> ${readMore}`}
                              />
                            </span>
                          </Button>
                        </Grid>
                      )}
                    </Grid>
                  )
          }

        </div>
      );
    }
}


function mapStateToProps({ scroll }) {
  return {
    scroll: scroll.data,
  };
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps)(CardDeals)));
